// extracted by mini-css-extract-plugin
export default {"form-row":"form-row__xs8Fn","checkbox-label":"checkbox-label__di18t"};